"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.register = exports.get = exports.dataMap = exports.dataList = exports.EDiveTile = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var EDiveTile;
(function (EDiveTile) {
    EDiveTile[EDiveTile["Default"] = -1] = "Default";
    // Simple
    EDiveTile[EDiveTile["Null"] = 0] = "Null";
    EDiveTile[EDiveTile["Floor"] = 1] = "Floor";
    EDiveTile[EDiveTile["Wall"] = 2] = "Wall";
    // Pits / liquids
    EDiveTile[EDiveTile["Hole"] = 10] = "Hole";
    EDiveTile[EDiveTile["Acid"] = 11] = "Acid";
    // Objects
    // Lamp = 20,
    // Stairs
    EDiveTile[EDiveTile["StairsUp"] = 50] = "StairsUp";
    EDiveTile[EDiveTile["StairsDown"] = 51] = "StairsDown";
    // Doors
    EDiveTile[EDiveTile["DoorClosed"] = 60] = "DoorClosed";
    EDiveTile[EDiveTile["DoorOpen"] = 61] = "DoorOpen";
})(EDiveTile = exports.EDiveTile || (exports.EDiveTile = {}));
var _default = {
    type: EDiveTile.Default,
    // layer: 2,
    frames: sprites_sidecar_1.sprites.diveTiles03C3,
    canWalk: false,
    // colors: voyageColors.all,
    includesText: false,
    isNull: false,
    pathfindPenalty: 0,
    cover: 0,
};
exports.dataList = [];
exports.dataMap = [];
var dataType = 'dive-tiles';
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetDataNum(dataType, exports.dataMap, type);
};
exports.get = get;
var register = function (data) {
    entitiesUtils_sidecar_1.entitiesUtils.genericRegisterDataNum(dataType, data, _default, exports.dataList, exports.dataMap);
};
exports.register = register;
// export const layer1: IDiveTileData[] = []
// export const layer2: IDiveTileData[] = []
// export const layer3: IDiveTileData[] = []
function registerAll() {
    exports.register({
        type: EDiveTile.Wall,
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveTiles10C8)), __read(sprites_sidecar_1.sprites.diveTiles11C9)), __read(sprites_sidecar_1.sprites.diveTiles12C10)),
        canWalk: false,
        cover: 2,
        // layer: 1,
        // colors: [voyageColors.g1],
        // isNull: true,
    });
    exports.register({
        type: EDiveTile.Floor,
        frames: sprites_sidecar_1.sprites.diveTiles00C0,
        canWalk: true,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EDiveTile.Acid,
        frames: sprites_sidecar_1.sprites.diveTiles03C3,
        canWalk: false,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EDiveTile.Hole,
        frames: sprites_sidecar_1.sprites.diveTiles02C2,
        canWalk: false,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    // register({
    //   type: EDiveTile.Lamp,
    //   frames: [...sprites.diveTiles20C16, ...sprites.diveTiles21C17],
    //   canWalk: false,
    //   // layer: 1,
    //   // colors: [voyageColors.g2],
    //   //    isNull: true,
    // })
    exports.register({
        type: EDiveTile.StairsUp,
        frames: sprites_sidecar_1.sprites.diveTiles40C32,
        canWalk: true,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EDiveTile.StairsDown,
        frames: sprites_sidecar_1.sprites.diveTiles41C33,
        canWalk: true,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EDiveTile.DoorClosed,
        frames: sprites_sidecar_1.sprites.diveTiles30C24,
        canWalk: true,
        cover: 2,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EDiveTile.DoorOpen,
        frames: sprites_sidecar_1.sprites.diveTiles31C25,
        canWalk: true,
        // layer: 1,
        // colors: [voyageColors.g2],
        //    isNull: true,
    });
    // layer1.push(...l.filter(dataList, (c) => c.layer === 1))
    // Object.freeze(layer1)
    // layer2.push(...l.filter(dataList, (c) => c.layer === 2))
    // Object.freeze(layer2)
    // layer3.push(...l.filter(dataList, (c) => c.layer === 3))
    // Object.freeze(layer3)
}
exports.registerAll = registerAll;
